import config from '@/properties';
import Vue from 'vue';

const SERVER_URL = config.SERVER_URL;

class OpenAPI {

  static getStatic() {
    return Vue.http.get(SERVER_URL + '/api/static');
  }

  static getFaq() {
    return Vue.http.get(SERVER_URL + '/api/static/faqs');
  }

  static getDisclaimer() {
    return Vue.http.get(SERVER_URL + '/api/static/disclaimer');
  }

  static getLegend(params) {
    return Vue.http.get(SERVER_URL + '/api/legend', {
      params
    });
  }

  static getCurrentCoverage(params) {
    return Vue.http.get(SERVER_URL + '/api/legend/level', {
      params
    });
  }

  static screenVisited(screen, version, platform) {
    if (!screen || !version || !platform) return;
    return Vue.http.post(SERVER_URL + '/api/statistics/screen', [{
      screen,
      version,
      platform
    }]);
  }

  static sendMapStat(data) {
    if (!data) return;
    return Vue.http.post(SERVER_URL + '/api/statistics/map', [data]);
  }

  static getComparisonAllCoverage(params) {
    return Vue.http.get(SERVER_URL + '/api/comparison/all', {
      params
    });
  }
}

export default OpenAPI;
